var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnician(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "Technician",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 2.667,
    x2: 26.537,
    y1: 16.498,
    y2: 16.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34a853",
    className: "stopColor2b2e81 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColorbe4f9c svgShape"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M21.9 24.8c0-.1 0-.1-.1-.2-.1-.2-.1-.3-.2-.5V24c-.5-1.2-1.5-2.2-2.8-2.6L14.5 20v-2c1.3-.9 2.2-2.3 2.5-3.9h.6c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5l.5-1.4c.2-.8 0-1.5-.5-2.1-.4-.5-.9-.8-1.5-.9-.1-.7-.5-1.4-1-1.9-.7-.6-1.6-.8-2.4-.7l-6 1c-1 .1-1.7.5-2.1 1.2-.5.6-.7 1.4-.5 2.3l.6 2.4h-.2c-.8 0-1.5.7-1.5 1.5v1c0 .8.7 1.5 1.5 1.5h.6c.3 1.6 1.2 3 2.5 3.9v2l-4.3 1.4C2 21.7 1 22.7.5 23.9v.1c-.1.2-.1.3-.2.5 0 .1 0 .1-.1.2 0 .1-.1.3-.1.4-.1.3-.1.5-.1.7v3.7c0 .3.2.5.5.5h20.9c.3 0 .5-.2.5-.5v-3.7c0-.2 0-.4-.1-.7.1-.1.1-.2.1-.3zM17.5 11c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H17v-1.6l.1-.4h.4zM5.4 5.8c.3-.4.8-.7 1.3-.8l6-1c.6-.1 1.2.1 1.6.4.4.4.7 1 .7 1.6 0 .3.2.5.5.5.5 0 .9.2 1.2.6.3.4.4.8.3 1.2l-.9 2.7H16c-.3 0-.5-.2-.5-.5 0-.8-.7-1.5-1.5-1.5H8c-.8 0-1.5.7-1.5 1.5 0 .3-.2.5-.5.5h-.1L5 7.4c-.1-.6.1-1.1.4-1.6zM5 13h-.5c-.3 0-.5-.2-.5-.5v-1c0-.3.2-.5.5-.5h.4l.1.4V13zm1 0v-1c.8 0 1.5-.7 1.5-1.5 0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5 0 .8.7 1.5 1.5 1.5v1c0 2.8-2.2 5-5 5s-5-2.3-5-5zm5 6c.9 0 1.7-.2 2.4-.5v1.4c0 .3-.1.5-.4.8-.5.6-1.3 1-2.1 1s-1.6-.4-2.1-1c-.2-.3-.4-.6-.4-.8v-1.4c.9.3 1.7.5 2.6.5zm-7.5 3.3 4.3-1.4c.1.1.2.2.3.4.7.9 1.7 1.4 2.9 1.4 1.1 0 2.2-.5 2.9-1.4.1-.1.2-.3.3-.4l4.3 1.4c.6.2 1.2.6 1.6 1-2.4.7-4.1 2.8-4.1 5.4v.3H6v-.3c0-2.6-1.7-4.7-4-5.4.4-.4.9-.8 1.5-1zM1 29v-3.2c0-.3 0-.5.1-.8v-.1c.1-.3.1-.5.3-.7 2.1.4 3.6 2.3 3.6 4.5v.3H1zm20 0h-4v-.3c0-2.2 1.6-4 3.7-4.5.1.2.2.5.3.7v.1c.1.3.1.5.1.8V29z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 2.667,
    x2: 26.537,
    y1: 9.988,
    y2: 9.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34a853",
    className: "stopColor2b2e81 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColorbe4f9c svgShape"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M24 2c-2.4 0-4.6 1-6.1 2.9-.2.2-.1.5.1.7.2.2.5.1.7-.1C20 3.9 21.9 3 24 3c3.9 0 7 3.1 7 7s-3.1 7-7 7c-1.4 0-2.8-.4-4-1.3-.2-.2-.5-.1-.7.1-.2.2-.1.5.1.7 1.4 1 2.9 1.5 4.6 1.5 4.4 0 8-3.6 8-8s-3.6-8-8-8z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.667,
    x2: 26.537,
    y1: 9.883,
    y2: 9.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#34a853",
    className: "stopColor2b2e81 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea4335",
    className: "stopColorbe4f9c svgShape"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21 12.1c-.2 0-.3.1-.4.3l-.6 1.2c-.1.2 0 .5.2.7.2.1.5 0 .7-.2l.5-1 1.2-.1.7 1-.5 1c-.1.2 0 .5.2.7h.2c.2 0 .4-.1.5-.3l.6-1.2c.1-.2.1-.4 0-.5l-.8-1.2 2.2-4.7 1.3-.2c.2 0 .3-.1.4-.3l.6-1.2c.1-.2 0-.5-.2-.7-.2-.1-.5 0-.7.2l-.5 1-1.2.1-.7-1 .5-1c.1-.2 0-.5-.2-.7-.2-.1-.5 0-.7.2l-.6 1.2c-.1.2-.1.4 0 .5l.8 1.2-2.1 4.9-1.4.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnician);
export default __webpack_public_path__ + "static/media/technician.9ef03f55091ea904037fa955a985d6f8.svg";
export { ForwardRef as ReactComponent };